import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance } from 'vue'  
  import store from '@/store'     
  import { i18n } from '@/locale/vueI18n'  
  import { VuetifyConfirmObject } from 'vuetify-confirm/types'
  import { getDefaultGliderCoverageConfig } from '@/models/iris/smartMission/IGliderCoverageConfig'  
  import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
  import { AloDbFleet, AloDbFleetCoverage } from '@/models/alodb/AloDbFleet'

  // Accès aux plugins Vue via l'instance (Vue 2 + Composition API)
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FleetCoverageParameter',
  setup(__props) {

    
  const instance = getCurrentInstance()
  const $options = instance?.proxy?.$options!
  const $confirm = instance?.proxy?.$confirm!
  const $set  = instance?.proxy?.$set!

  const selectedGliderIdx = ref(-1)

  const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleetCoverage)
  
  const param = computed(()=> modified.value.param)
  const config = computed(() => modified.value.config)
  const drawArea = ref<HTMLCanvasElement | null>(null)
  


  const deprecoModes = computed(()=>{
    return [
      {libelle:i18n.t("Simulation.Common"),value:true},
      {libelle:i18n.t("Simulation.Optimal"),value:false},
    ]
  })

  const gridPointList = computed(()=>{
    //@ts-ignore
    return modified.value.resultGridJson?.wpts?.map(w => ({libelle:`N°${w.wpt_label}  (${$options.filters[store.myGetters.coordFormatFilter]([w.wpt_lon,w.wpt_lat])})`,id:w.id})) ?? []
  })
  
   const dicPosition = computed(()=> Object.keys(modified.value.config.glider_association).reduce((dic,key) => {
                dic[modified.value.config.glider_association[key]?.at(0)?.toString() ?? key] = parseInt(key.replace('GLIDER',''))
                return dic
            },{} as Record<string,number>))

  const gliderConfigKeys = computed(() => Object.keys(modified.value.config.gliders_config).sort((a,b) => (dicPosition.value[a] ?? Number.MAX_SAFE_INTEGER) - (dicPosition.value[b] ?? Number.MAX_SAFE_INTEGER)))

  const currentEditProfil = computed(()=>{    
    const gliKey = gliderConfigKeys.value[selectedGliderIdx.value]
    if(modified.value.config?.gliders_config[gliKey] && !modified.value.config?.gliders_config[gliKey]?.prf_nav?.length){
      $set(modified.value.config.gliders_config[gliKey],"prf_nav",[{...MissionPlanUiState.getDefaultProfil(),id:1}])
    }
    return modified.value.config?.gliders_config[gliKey]?.prf_nav?.at(0)    
  })

  function addGliderConfig() {
    const nbGlider = gliderConfigKeys.value.length
    $set(modified.value.config.gliders_config,`GLIDER${nbGlider+1}`, getDefaultGliderCoverageConfig())
    selectedGliderIdx.value = nbGlider
    AloDbFleet.correctGliderAssociation(modified.value)
  }

  function deleteGliderConfig(gliKey:string) {
      $confirm(i18n.t('Admin.DeleteDialogMessage').toString(),{title: i18n.t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {     
          modified.value.config!.gliders_config = gliderConfigKeys.value.reduce((acc, key) => {
            if (key !== gliKey) {
              acc[key] = modified.value.config!.gliders_config[key]
            } 
            return acc
          }, {} as Record<string, any>)  
          AloDbFleet.correctGliderAssociation(modified.value)
        } 
      })   
  }
 


return { __sfc: true,instance, $options, $confirm, $set, selectedGliderIdx, modified, param, config, drawArea, deprecoModes, gridPointList, dicPosition, gliderConfigKeys, currentEditProfil, addGliderConfig, deleteGliderConfig }
}

})